<template>
    <v-text-field
        v-model="username"
        :rules="obligatorio"
        label="Nombre de usuario"
        required
        variant="solo"
    ></v-text-field>
    <v-btn
        @click="buscarUsuario"
        :disabled="!username"
        id="boton-verde"
        :loading="cargando"
    >
        Buscar
    </v-btn>
    <ClosableAlert
        v-if="alert"
        :type="alertType"
        :key="alertKey"
        :texto="mensaje"
        titulo="Usuario"
    ></ClosableAlert>
</template>
<style src="../assets/general.css"></style>
<script>
    import ClosableAlert from './ClosableAlert.vue';
    import { obligatorio } from '@/_helpers/rules';
    import AuthService from '@/api/AuthService';

    const authService = new AuthService();

    export default {
        name: 'BuscarUsuario',
        components: {
            ClosableAlert
        },
        data() {
            return {
                username: '',
                cargando: false,
                obligatorio : obligatorio,
                alert: false,
                alertType: '',
                mensaje: '',
                alertKey: 0
            };
        },
        methods: {
            async buscarUsuario() {
                this.cargando = true;
                const response = await authService.buscarUsuario(this.username);
                if(response && response.status === 200) {
                    if(response.data.habilitado){
                        this.alertType = 'success';
                        this.mensaje = "Usuario existente con nombre de usuario: " + response.data.username + " y correo: " + response.data.email;
                    } else {
                        this.alertType = 'info';
                        this.mensaje = "Usuario existente con nombre de usuario: " + response.data.username + " y correo: " + response.data.email + " pero inhabilitado";
                    }
                } else {
                    this.alertType = 'error';
                    this.mensaje = response.data.mensaje;
                }
                this.alert = true;
                this.alertKey++;
                this.cargando = false;
            }
        },
    };
</script>